import React from 'react'
import { IOption } from '../../common/common.types'
import SingleSelect from '../singleSelect/SingleSelect.component'
import './LabeledSelect.component.css'

export interface ILabeledSelectProps {
  className?: string
  prefixLabel: string
  label: string
  options: IOption[]
  selectedOption: IOption | null
  onOptionChange: (option: IOption, dispatchData?: unknown) => void
  listHeader?: string
  dataTestID: string
  icon?: React.ReactNode
  disabled?: boolean
  hideClearButton?: boolean
}

const LabeledSelect: React.FC<ILabeledSelectProps> = ({
  className = '',
  prefixLabel,
  label,
  options,
  selectedOption,
  onOptionChange,
  listHeader,
  dataTestID,
  icon,
  disabled = false,
  hideClearButton = false,
}) => {
  return (
    <div className={`labeled-select-container ${className}`}>
      <div className='labeled-select-label'>
        {icon && <div className='labeled-select-icon'>{icon}</div>}
        <label>{prefixLabel}</label>
      </div>
      <div className='labeled-select-select'>
        <SingleSelect
          dataTestID={dataTestID}
          options={options}
          selectedOption={selectedOption}
          listHeader={listHeader || label}
          action={onOptionChange}
          disabled={disabled}
          hideClearButton={hideClearButton}
          label={label}
        />
      </div>
    </div>
  )
}

export default LabeledSelect
